module.exports = __webpack_public_path__ + "img/rknT2.e1e4f9fb.jpeg";